import { useMutation, useQuery } from '@tanstack/react-query';
import {
  DashFilters,
  exportDash,
  getActionQueueCheck,
  getDash,
  RansackParams
} from '../api/dash';

export const useDashQuery = (filters?: DashFilters) => {
  return useQuery({
    queryKey: ['dash', filters],
    queryFn: () => getDash(filters)
  });
};

export const useActionQueueCheckQuery = () => {
  return useQuery({
    queryKey: ['actionQueueCheck'],
    queryFn: () => getActionQueueCheck()
  });
};

// Fire-and-forget: the export is emailed out by a background job, so there is
// nothing cached to invalidate on success.
export const useDashExportMutation = () => {
  return useMutation({
    mutationFn: ({ q, year }: { q: RansackParams; year?: string }) => exportDash(q, year)
  });
};
